import type { CountdownProps } from '@builder4/shared/components/Countdown';
import { SliderField } from './SliderField';
import { useNode } from '@craftjs/core';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';

interface NodeCountdownSpaceSettingsProps {
  text?: string;
  type: 'number' | 'label';
}

const NodeCountdownSpaceSettings = ({
  text = 'Spacing',
  type = 'number',
}: NodeCountdownSpaceSettingsProps) => {
  const {
    props,
    displayName,
    actions: { setProp },
  } = useNode((node) => ({
    id: node.id,
    props: node.data.props,
    displayName: node.data.displayName,
  }));

  const { setBPProp, getBPProp } = useBreakpointAwareProp(displayName);

  const numberLetterSpacing = getBPProp(props, 'numberLetterSpacing');
  const labelLetterSpacing = getBPProp(props, 'labelLetterSpacing');

  const getLetterSpacing = () => {
    const finalLetterSpacing =
      type === 'number' ? (numberLetterSpacing ?? 0) : (labelLetterSpacing ?? 0);
    return finalLetterSpacing;
  };

  const handleOnChange = (value: number) => {
    setProp((props: CountdownProps) => {
      if (type === 'number') {
        setBPProp(props, 'numberLetterSpacing', value);
      } else {
        setBPProp(props, 'labelLetterSpacing', value);
      }
    }, 500);
  };

  return (
    <SliderField
      label={text}
      value={getLetterSpacing()}
      onChange={handleOnChange}
      onChangeComplete={handleOnChange}
      min={-2}
      max={2}
      step={0.01}
      allowDecimal={true}
    />
  );
};

export default NodeCountdownSpaceSettings;
